import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceDetailReport  {
    _originalTypeClassName = "zERP.BO.InvoiceDetailReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceDetailReport.translate = translateService;
}
this.VatCategory = null;
this.VatAmount = null;
this.NetAmount = null;
this.GrossAmount = null;
this.InvoiceDetailReportKey = null;
this._key = this.InvoiceDetailReportKey = 0; 
}

static translate: TranslateService;
_key: any;
VatCategory:any;
VatAmount:any;
NetAmount:any;
GrossAmount:any;
private _InvoiceDetailReportKey:any;
get InvoiceDetailReportKey(): any {
    return this._InvoiceDetailReportKey;
  }
set InvoiceDetailReportKey(value: any) {
    this._InvoiceDetailReportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceDetailReportKey == null || $this.InvoiceDetailReportKey == 0;
            }


}